import Marquee from "react-fast-marquee";
import Reveal from "@/components/site/Reveal";
import { FEATURES, IMAGES } from "@/lib/content";

export default function Craftsmanship() {
    return (
        <section
            data-testid="craftsmanship-section"
            className="bg-[#0a0a0a] text-white border-t border-white/10"
        >
            {/* Marquee */}
            <div className="py-10 lg:py-12 border-b border-white/10 marquee-wrap">
                <Marquee
                    gradient={false}
                    speed={40}
                    pauseOnHover={true}
                    className="font-serif italic text-white/70"
                >
                    {[
                        "Hand-cut",
                        "Saddle-stitched",
                        "Bespoke Fit",
                        "Edge-burnished",
                        "Full-grain only",
                        "Lasted by hand",
                        "Repaired for life",
                        "Since 1992",
                    ].map((word, i) => (
                        <span
                            key={i}
                            className="mx-8 lg:mx-14 text-4xl sm:text-5xl lg:text-6xl tracking-tight flex items-center"
                        >
                            {word}
                            <span className="ml-8 lg:ml-14 text-white/20">✦</span>
                        </span>
                    ))}
                </Marquee>
            </div>

            {/* Feature list */}
            <div className="px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-4">
                        <Reveal>
                            <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-8">
                                02 · The Making
                            </p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="font-serif text-5xl lg:text-6xl font-medium leading-[0.95] tracking-tight">
                                Four rules
                                <br />
                                we don't
                                <br />
                                <em className="font-normal">break</em>.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.3} y={60}>
                            <div className="mt-14 relative aspect-[3/4] overflow-hidden">
                                <img
                                    src="brand/tanshoes.jpg"
                                    alt="Artisan at work"
                                    className="w-full h-full object-cover grayscale"
                                />
                            </div>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-8 lg:pl-10">
                        <ul className="divide-y divide-white/10 border-y border-white/10">
                            {FEATURES.map((f, idx) => (
                                <Reveal key={f.index} delay={idx * 0.08} y={30}>
                                    <li
                                        data-testid={`feature-${f.index}`}
                                        className="group py-10 lg:py-14 grid grid-cols-12 items-start gap-6 transition-colors"
                                    >
                                        <span className="col-span-2 lg:col-span-1 font-mono-custom text-xs text-white/40 tracking-widest pt-2">
                                            {f.index}
                                        </span>
                                        <div className="col-span-10 lg:col-span-11 grid grid-cols-1 lg:grid-cols-12 gap-6">
                                            <h3 className="lg:col-span-5 font-serif text-2xl lg:text-3xl font-medium tracking-tight leading-tight transition-transform duration-500 group-hover:translate-x-2">
                                                {f.title}
                                            </h3>
                                            <p className="lg:col-span-7 text-base text-white/60 font-light leading-relaxed max-w-xl">
                                                {f.text}
                                            </p>
                                        </div>
                                    </li>
                                </Reveal>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
